import React, {Component} from "react"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import GenericModal from "@irati/ui/src/GenericModal"
import {Body} from "@irati/ui/src/Typography"
import success from "@irati/ui/images/success.svg"

interface Props extends InjectIntl {
  title: string,
  show: boolean,
  onToggle: () => void,
  successfullyUpdatedUsers: string,
  usersAlreadyInTeam?: string
}

class MoveUsersSuccessModal extends Component<Props> {
  render() {
    const {
      formatMessage,
      title,
      show,
      onToggle,
      successfullyUpdatedUsers,
      usersAlreadyInTeam
    } = this.props

    return (
      <GenericModal
        critical
        image={success}
        show={show}
        title={formatMessage({id: title})}
        proceedButtonText={formatMessage({id: "admin.components.manageUsersPopUp.moveTeamPopupSuccess.proceedButtonText"})}
        onConfirm={onToggle}
        onHide={onToggle}>
        <Body marginBottom={1}>{successfullyUpdatedUsers}</Body>
        {usersAlreadyInTeam && <Body marginBottom={1}>{usersAlreadyInTeam}</Body>
        }
      </GenericModal>
    )
  }
}

export default injectIntl(MoveUsersSuccessModal)
